import { forwardRef } from "react";

import {
  DEFAULT_ICON_COLOR,
  DEFAULT_ICON_SIZE,
} from "@oneleet/config/constants";
import { cn } from "@oneleet/utils";

export const BrandWindowsIcon = forwardRef<
  SVGSVGElement,
  { className?: string }
>(({ className }, ref) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 4875 4875"
      className={cn(
        "fill-current",
        DEFAULT_ICON_SIZE,
        DEFAULT_ICON_COLOR,
        className,
      )}
      ref={ref}
    >
      <path
        d="M0 0h2311v2310H0zm2564 0h2311v2310H2564zM0 2564h2311v2311H0zm2564 0h2311v2311H2564"
        fill="currentColor"
      />
    </svg>
  );
});

BrandWindowsIcon.displayName = "BrandWindowsIcon";

export default BrandWindowsIcon;
